import { IPrices } from './prices.model';

export interface IUserResponse {
	token: string;
	user: IUser;
	prices: IPrices;
	workers: IWorker[];
}

export interface IUser {
	id: number
	user_display_name: string
	user_email: string
	user_nicename: string
	role: IUserRoles[]
}

export interface IWorker {
	phone: string,
	id: number,
	name: string,
	roles: IUserRoles[]
	email: string
}

export enum IUserRoles {
	ADMIN = 'administrator',
	HELPER = 'helper',
	FOREMAN = 'foreman',
	MANAGER = 'manager'
}